import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import Validator from './common/forms/Validator';
import ErrorMessage from './common/forms/ErrorMessage';
import SwitchRow from './common/forms/SwitchRow';
import FormActionButtons from './common/forms/FormActionButtons';
import Close from './common/ui/Close';

export default class ChangeUserPasswordModal extends Validator {
  static propTypes = {
    handleChangePassword: PropTypes.func.isRequired
  };

  state = {
    modalIsOpen: false,
    newPassword: '',
    temp_password: true
  };

  validationRules = {
    newPassword: { password: true }
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modalIsOpen: !prevState.modalIsOpen
    }));
  };

  handleCheckbox = name =>
    this.setState(prevState => ({
      [name]: !prevState[name]
    }));

  handleChange = event => {
    this.setState({
      newPassword: event.target.value
    });
  };

  closeAndClearForm = () => {
    this._resetErrors();
    this.setState({
      modalIsOpen: false,
      newPassword: '',
      temp_password: true
    });
  };

  submitChangePassword = event => {
    event.preventDefault();
    event.stopPropagation();
    if (this.validate(this.validationRules)) {
      const { newPassword, temp_password } = this.state;
      this.props.handleChangePassword(newPassword, temp_password).then(resp => {
        if (resp) {
          this.closeAndClearForm();
        }
      });
    }
  };

  render () {
    const { modalIsOpen, newPassword, temp_password } = this.state;
    const errors = this.validationErrors;
    return (
      <div className='section-row'>
        <button className='button button-primary' type='button' onClick={this.toggleModal}>Change Password</button>

        <Modal isOpen={modalIsOpen} toggle={this.toggleModal}>
          <div className='modal-header'>
            <div className='modal-title'>Change Password</div>
            <Close onClick={this.toggleModal} />
          </div>
          <form onSubmit={this.submitChangePassword} className='modal-body'>
            <div className='form-group'>
              <label htmlFor='newPassword'>New Password</label>
              <input
                className='input'
                id='newPassword'
                name='newPassword'
                value={newPassword}
                onChange={this.handleChange}
              />
              <ErrorMessage errorText={errors.newPassword} />
            </div>
            <div className='form-group'>
              <SwitchRow onChange={() => this.handleCheckbox('temp_password')} checked={temp_password} label='Force Password Reset' />
            </div>

            <FormActionButtons onClickCancel={this.closeAndClearForm} submitTitle='Done' />
          </form>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangeUserPasswordModal.js